export default function (nga, admin, menu) {
    var _ename = 'expiringsubscriptions';
    var _epretty = 'Expiring Subscriptions';
    var _entity = nga.entity(_ename).url('users/expiringsubscriptions').readOnly();
    
    var date = new Date();
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 1);

    
    _entity.listView()
        .title(_epretty)
        .filters([
            nga.field('start', 'date').label('Report Start').defaultValue(firstDay.toString('yyyy-MM-dd')).pinned(true),
            nga.field('end', 'date').label('Report End').defaultValue(lastDay.toString('yyyy-MM-dd')).pinned(true)
        ])
        .fields([
            nga.field('id').label('ID'),
            nga.field('product_id', 'reference')
                .targetEntity(nga.entity('products'))
                .targetField(nga.field('code'))
                .label('Product'),
            nga.field('validity').label('Final De Subscrição'),
            nga.field('user_id', 'reference')
                .targetEntity(nga.entity('users'))
                .targetField(nga.field('email'))
                .label('User')
        ]);

    admin.addEntity(_entity);
    
    menu.addChild(nga.menu(_entity).title(_epretty));
    
    return _entity;
}


// WEBPACK FOOTER //
// ./js/entities/expiringsubscriptions.js